
<template>
  <!-- <el-scrollbar wrap-class="scrollbar-wrapper"> -->
  <el-menu :default-active="activeMenu" :background-color="variables.menuBg" :text-color="variables.menuText" :active-text-color="variables.menuActiveText" mode="horizontal">
    <sidebar-item v-for="route in routes" :key="route.path" :item="route" :base-path="route.path" />
    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <!-- <search id="header-search" class="right-menu-item" /> -->
        <!-- <error-log class="errLog-container right-menu-item hover-effect" /> -->
        <!-- <screenfull id="screenfull" class="right-menu-item hover-effect" /> -->
        <!-- <el-tooltip :content="$t('navbar.size')" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip> -->
        <!-- <lang-select class="right-menu-item hover-effect" /> -->
      </template>
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper" style="display: flex;">
          <div style="font-size: 16px;">奥特曼
            <!-- {{ $store.state.user.compshortname }} &nbsp; &nbsp; &nbsp; &nbsp;{{ $store.state.user.compshortname === $store.state.user.name?"":$store.state.user.name }} -->
          </div>
          <img src="https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif" class="user-avatar">
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <!-- <router-link to="/">
            <el-dropdown-item>
              首页
            </el-dropdown-item>
          </router-link> -->
          <!-- <el-dropdown-item>
            <span style="display:block;" @click="drawer = true">基本资料</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">修改密码</span>
          </el-dropdown-item> -->
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-drawer title="基本资料" :visible.sync="drawer" size="400px" direction="rtl" :before-close="closeDrawer">
      <!-- @submitForm="subData" @detailButton="previewfile" @choice="choice" -->
      <div style="text-align: center;margin-bottom: 50px;">
        <!-- :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" -->
        <el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/" :show-file-list="false">
          <img v-if="imageUrl" :src="imageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon" />
        </el-upload>
      </div>

      <customForm :columns="formcolumns" :form-data="informationMainData">
        <!-- <template slot="headSculpture">
          <el-upload
            class="avatar-uploader"
            action="https://jsonplaceholder.typicode.com/posts/"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
        </template> -->
      </customForm>
    </el-drawer>
  </el-menu>

  <!-- </el-scrollbar> -->

</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";

export default {
  name: "HeadNavbar",
  components: { SidebarItem },
  data() {
    return {
      menu: []
    };
  },
  computed: {
    ...mapGetters(["permission_routes", "sidebar"]),
    // activeMenu() {
    //   const route = this.$route;
    //   console.log("route", route);
    //   const { meta, path } = route;
    //   // if set path, the sidebar will highlight the path you set
    //   if (meta.activeMenu) {
    //     return meta.activeMenu;
    //   }
    //   return path;
    // },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
    created() {
      return this.$router.options.routes.concat(global.antRouter);
    },
    routes() {
      return this.$router.options.routes.concat(global.antRouter);
    }
  },
  mounted() { }
};
</script>
<style lang="scss" scoped>
.right-menu {
  float: right;
  height: 100%;
  line-height: 50px;

  &:focus {
    outline: none;
  }

  .right-menu-item {
    display: inline-block;
    padding: 0 8px;
    height: 100%;
    font-size: 18px;
    color: #5a5e66;
    vertical-align: text-bottom;

    &.hover-effect {
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  .avatar-container {
    margin-right: 30px;
    .avatar-wrapper {
      margin-top: 5px;
      position: relative;
      .user-avatar {
        cursor: pointer;
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>
